import { Dispatch } from 'redux'
import { throwErrorWithMessage } from 'api/apiMessages'

import * as LibraryApi from './Library.api'
import {
  ActionType,
  GetLibrary,
  GetLibraryShelfPage,
  GetTimeSpentAction,
  SetShouldRefetchLibrary
} from './Library.types'

export const getLibrary = (searchPhrase?: string) => async (dispatch: Dispatch<GetLibrary>) => {
  try {
    const libraryContent = await LibraryApi.getLibrary(searchPhrase)
    dispatch({ type: ActionType.GetLibrary, libraryContent })
    return libraryContent
  } catch (error) {
    return throwErrorWithMessage(error)
  }
}

export const getLibraryShelfSectionPage =
  (sectionId: string, paginationOptions: { before: string } | { after: string }) =>
  async (dispatch: Dispatch<GetLibraryShelfPage>) => {
    try {
      const newSectionPage = await LibraryApi.getLibraryPage(sectionId, paginationOptions)

      return dispatch({
        type: ActionType.UpdateSectionEntries,
        newSectionPage,
        sectionId
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }

export const setShouldRefetchLibrary = (shouldRefetch: boolean) => (dispatch: Dispatch<SetShouldRefetchLibrary>) =>
  dispatch({ type: ActionType.SetShouldRefetchLibrary, shouldRefetch })

export function asyncGetStudyTime(timezone: string) {
  return async function (dispatch: Dispatch<GetTimeSpentAction>) {
    try {
      const response = await LibraryApi.getStudyTime(timezone)

      return dispatch({
        type: ActionType.GetTimeSpent,
        timeSpent: response.data.timeSpent
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}
